import { render, staticRenderFns } from "./Croppa.vue?vue&type=template&id=3a1d5bde&scoped=true&"
import script from "./Croppa.vue?vue&type=script&lang=js&"
export * from "./Croppa.vue?vue&type=script&lang=js&"
import style0 from "./Croppa.vue?vue&type=style&index=0&id=3a1d5bde&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a1d5bde",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VCol,VIcon})
